<ng-container >
    <button mat-raised-button (click)="uploadImage()" class="flex items-center justify-center px-4 w-full" [color]="'primary'">
        <mat-icon class="text-white">cloud_upload</mat-icon>
        <p class="pl-2">Cargar Archivos</p>
    </button>

    <input
        type="file"
        accept=".pdf,
          .docx,
          .xlsx,
          .png,
          .jpg,
          .jpeg,
          .gif,
          application/pdf,
          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
          image/*"
        multiple
        (change)="onFileSelected($event)"
        class="hidden"
        #fileInput>
</ng-container>
